import router, { useRouter } from "next/router";
import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { menuData } from "../../data/PublicMenuData";
import { Color } from "../../theme/Color";
import Button from "../Button/Button";
import Spacer from "../Spacer";
import MobileMenuItem from "./MobileMenuItem";

interface Props {
  setShowMenu: (boolean) => any;
}

const StyledMobileMenu = styled(Col)`
  color: ${Color.Grey1};
`;

const MobileMenu = ({ setShowMenu }: Props) => {
  const { asPath } = useRouter();
  const [showSignUpMenu, setShowSignUpMenu] = useState(false);

  const mobilePrimaryMenu = menuData.map((menuItem, index) => {
    if (menuItem.title != "Login" && menuItem.title != "Sign Up") {
      return (
        <Row key={index}>
          <MobileMenuItem
            title={menuItem.title}
            link={menuItem.link}
            isActive={menuItem.link === asPath ? true : false}
            setShowMenu={setShowMenu}
            menuItemType={menuItem.childMenu ? "parent" : null}
          />

          {menuItem.childMenu &&
            menuItem.childMenu.map((childMenuItem, index) => {
              return (
                <MobileMenuItem
                  key={index}
                  title={childMenuItem.title}
                  link={childMenuItem.link}
                  isActive={childMenuItem.link === asPath ? true : false}
                  setShowMenu={setShowMenu}
                  menuItemType="child"
                />
              );
            })}
        </Row>
      );
    }
  });

  return (
    <>
      <StyledMobileMenu>
        {!showSignUpMenu && (
          <Spacer top={7}>
            <Spacer top={2} bottom={1}>
              <Row center="xs">
                <Col xs={6}>
                  <Spacer left={1} right={1}>
                    <Button
                      label="Login"
                      size="large"
                      color="secondary"
                      onClick={() => {
                        setShowMenu(false);
                        router.push("/login");
                        setShowMenu(false);
                      }}
                    />
                  </Spacer>
                </Col>
                <Col xs={6}>
                  <Spacer left={1} right={1}>
                    <Button
                      label="Sign Up"
                      size="large"
                      onClick={() => {
                        setShowMenu(false);
                        router.push("/personal/register");
                      }}
                    />
                  </Spacer>
                </Col>
              </Row>
            </Spacer>
            {mobilePrimaryMenu}
          </Spacer>
        )}
      </StyledMobileMenu>
    </>
  );
};

export default MobileMenu;
